import React from 'react';
import './InfoMessageNoTitle.scss';
/** @import {InfoMessageNoTitleProps} from "./InfoMessageNoTitleTypes" */
export default function InfoMessageNoTitle(/** @type {InfoMessageNoTitleProps} */props) {
    return (
        <div className={"messageContainer"}>
            <div className={"messageContent"}>
                <div className={"messageArea"}>
                    <div className={"messageIconText"}>
                        <img
                            loading="lazy"
                            src="https://cdn.builder.io/api/v1/image/assets/TEMP/f2d20270adf2c37adfa59a5694ac8c8d56e529b00f8b244f64528a5e7c0f913a?placeholderIfAbsent=true&apiKey=818a1763d6f1455a8e12b5148c04fc79"
                            className={"messageIcon"}
                            alt="Information icon"
                        />
                        <div className={"messageBody"}>
                            <span className={"messageText"}>{props.body} </span>
                            <span className={"messageTextBold"}> {props.time} </span>
                            <span className={"messageText"}> on {props.date}.</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}